<template>
    <div class="notificationItem" @click="openDialog">
        <NotificationDialog ref="notificationDialog"/>

        <div class="notificationContainer" :class="{unread: !notification.read_at}">
            <div class="notificationHeader">
            <span class="notificationTitle">
                <text-highlight :queries="searchTitle">
                     {{ notification.title }}
                </text-highlight>
            </span>
                <span class="notificationDate">
                {{ notification.created_at | formatDateTime }}
            </span>
            </div>

            <div class="notificationText" ref="textBlock">
                <div class="textContainer" :class="{hiddenContent: !showFullText}">
                    <div class="textContent" v-html="notification.text"/>
                </div>

                <a v-if="isTextOverflow" class="showMoreBtn" @click.stop.prevent="toggleFullText" href="#">
                    {{ showFullText ? 'Скрыть' : 'Показать полностью' }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationDialog from "@dialogs/common/Notification";
import TextHighlight from "vue-text-highlight";

export default {
    components: {
        NotificationDialog,
        TextHighlight
    },
    props: {
        notification: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            isTextOverflow: false,
            showFullText: false,
        };
    },
    methods: {
        openDialog(e) {
            if (
                !e.target.classList.contains('showMoreBtn') &&
                e.target.tagName !== 'A' &&
                !e.target.closest('#notificationDialogShadow')
            ) {
                this.$refs.notificationDialog.show(this.notification);

                this.axios.post('notifications/markAsRead/' + this.notification.id)
                    .then(() => {
                        if (!this.notification.read_at) {
                            this.$emit('onRead');
                            this.$bus.fire('markOpenNotification', this.notification)
                        }
                    });
            }
        },
        toggleFullText() {
            this.showFullText = !this.showFullText;
        },
        checkIfTextIsOverflow() {
            this.isTextOverflow = this.$refs.textBlock.querySelector('.textContent').clientHeight > 230;
        }
    },
    computed: {
        searchTitle() {
            if (this.$parent.$parent.$parent.filter.title) {
                return this.$parent.$parent.$parent.filter.title.split(' ');
            }

            return '';
        },
    },
    mounted() {
        this.checkIfTextIsOverflow();

        window.addEventListener('resize', this.checkIfTextIsOverflow);
    },
    destroyed() {
        window.removeEventListener('resize', this.checkIfTextIsOverflow);
    },
}
</script>

<style>
.notificationRow {
    background-color: rgb(244, 244, 244) !important;

    .table-cell {
        padding: 0 5px;
    }

    .notificationContainer {
        border-radius: 2px;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
        margin-bottom: 10px;
        background-color: rgb(255, 255, 255);
        padding: 10px 0;
        cursor: pointer;

        &:hover {
            background-color: #f8f9fa;
        }

        &.unread {
            border-left: 4px solid #00a65a;

            .notificationHeader {
                font-weight: 700;
            }
        }

        .notificationHeader {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 10px 8px 10px;
            border-bottom: 1px solid lightgrey;

            .notificationTitle {
                font-size: 20px;
                margin-right: 5px;
            }

            .notificationDate {
                font-size: 16px;
                color: #666;
                white-space: nowrap;
            }
        }

        .notificationText {
            font-size: 16px;
            padding: 8px 10px 0 10px;

            .textContainer {
                overflow: hidden;

                &.hiddenContent {
                    max-height: 230px;
                }
            }

            .showMoreBtn {
                margin-top: 10px;
                display: inline-block;
            }
        }

        mark.text__highlight {
            background: #ff0;
        }
    }
}
</style>
